import React from 'react';
import cx from 'classnames';

var Spinner = function Spinner(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('smooth-spinner', color && color)
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: "5"
  })));
};

Spinner.displayName = 'Spinner';
var SpinnerDoc;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  SpinnerDoc = require('./doc').doc(Spinner);
}

var SpinnerWrapper = SpinnerDoc || Spinner;
export { SpinnerWrapper as Spinner };